import React from 'react';
import { observer } from 'mobx-react';

const Toaster = observer(class Toaster extends React.Component {
  constructor() {
    super();
    this.closeDialog = this.closeDialog.bind(this);
  }

  closeDialog(e) {
    e.preventDefault();
    this.props.store.SessionStore.closeDialog();
  }

  render() {
    const { SessionStore } = this.props.store;

    return(
      <div className={`toaster ${SessionStore.toasterClass}`}>
        <div className="wrap">
          <p>{SessionStore.toasterContent.body}</p>
        </div>
      </div>
    );
  }
})

export default Toaster;


// WEBPACK FOOTER //
// ./src/app/components/Common/Toaster.js